/**
 * 「保存中」「読み込み中」などの処理中を示す回転アニメーション (Issue #726)。
 *
 * - 見た目だけの装飾なので `aria-hidden="true"`。処理中であることの通知は、隣接する
 *   テキスト (「保存中...」など) や `disabled` 属性が担う。
 * - 色は `currentColor` を使うため、ボタン内 (primary の白文字など) でも文字色に追従する。
 * - `prefers-reduced-motion: reduce` の環境では回転を止める (styles.css 側で定義)。
 */
import type React from 'react';

export interface SpinnerProps {
  /** 表示サイズ。`sm` は文字と同じ高さ (既定)、`md` は画面中央のプレースホルダ用。 */
  size?: 'sm' | 'md';
  /** 追加の className */
  className?: string;
  'data-testid'?: string;
}

export function Spinner(props: SpinnerProps): React.JSX.Element {
  const { size = 'sm', className } = props;
  const classes = ['spinner', size === 'md' ? 'spinner--md' : '', className ?? '']
    .filter((c) => c !== '')
    .join(' ');
  return <span className={classes} aria-hidden="true" data-testid={props['data-testid']} />;
}

export default Spinner;
